// ISO paper sizes in mm (portrait), smallest first
const PAPER_SIZES = [
    {label: 'A6', width: 105, height: 148},
    {label: 'A5', width: 148, height: 210},
    {label: 'A4', width: 210, height: 297},
    {label: 'A3', width: 297, height: 420},
    {label: 'A2', width: 420, height: 594},
    {label: 'A1', width: 594, height: 841},
];

// How many paper sizes larger than the book's to show for comparison
const SIZES_ABOVE = 1;

// Layout in px - everything is drawn at pixel scale so text and lines stay the same size whatever the book size
const SVG_HEIGHT = 160;
const LABEL_GUTTER = 24;     // space left of the frames for the paper size labels
const TOP_PADDING = 7;       // room for the top label, which is centred on its frame's top edge
const CAPTION_HEIGHT = 18;   // room under the frames for the dimensions caption
const MIN_LABEL_GAP = 11;    // hide a label if it would overlap the one below it
const DRAW_HEIGHT = SVG_HEIGHT - TOP_PADDING - CAPTION_HEIGHT;

const BookCoverSize = dimensions => {

    let width = Number(dimensions.width);
    let height = Number(dimensions.height);

    // Nothing to draw without both dimensions
    if(!(width > 0 && height > 0)) return null;

    // Smallest paper size the book fits within, plus SIZES_ABOVE larger sizes for comparison (capped at the largest)
    let containerIndex = PAPER_SIZES.findIndex(size => height <= size.height && width <= size.width);
    if(containerIndex === -1) containerIndex = PAPER_SIZES.length - 1;
    containerIndex = Math.min(containerIndex + SIZES_ABOVE, PAPER_SIZES.length - 1);
    let sizes = PAPER_SIZES.slice(0, containerIndex + 1);
    let container = sizes[sizes.length - 1];

    // px per mm, so the container (or an oversized book) fills the drawing area
    let scale = DRAW_HEIGHT / Math.max(container.height, height, width * container.height / container.width);

    let baseline = SVG_HEIGHT - CAPTION_HEIGHT;
    let caption = `${height}mm (h) x ${width}mm (w)`;

    // Work down from the largest frame so the top label always shows
    let lastLabelY = -Infinity;
    let frames = sizes.slice().reverse().map(size => {
        let frameWidth = Math.round(size.width * scale);
        let frameHeight = Math.round(size.height * scale);
        let y = baseline - frameHeight;
        let showLabel = y - lastLabelY >= MIN_LABEL_GAP;
        if(showLabel) lastLabelY = y;

        return <g key={size.label}>
            <rect x={LABEL_GUTTER + 0.5} y={y + 0.5} width={frameWidth} height={frameHeight} fill="none" stroke="#555" strokeWidth="1"/>
            {showLabel && <text x={LABEL_GUTTER - 4} y={y} textAnchor="end" dominantBaseline="central" style={{fontSize: '12px'}}>{size.label}</text>}
        </g>;
    }).reverse();

    // Book page html
    return <div id="bookSize" className="bookSize" style={{height:`${SVG_HEIGHT}px`}} title={caption}>
        <div className="bookSizeFrame">
            <svg xmlns="http://www.w3.org/2000/svg" className="bookSizeSVG" style={{width: '100%', height: `${SVG_HEIGHT}px`}}>
                <g id="scale">{frames}</g>
                <g id="cover">
                    <rect id="bookCover" x={LABEL_GUTTER + 0.5} y={baseline + 0.5 - Math.round(height * scale)} width={Math.round(width * scale)} height={Math.round(height * scale)} fill="#007affcc"/>
                </g>
                <g id="caption">
                    <text id="bookCaption" x={LABEL_GUTTER} y={SVG_HEIGHT - 4} fill="#7a7a7a" style={{fontSize: '11px'}}>{caption}</text>
                </g>
            </svg>
        </div>
    </div>;
}

export default BookCoverSize;
